import { createAction, handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const registerRoutine = createRoutine("app/auth/register/REGISTER");
export const verifyOtpRoutine = createRoutine("app/auth/VERIFY_OTP");
export const verifyOtpHashRoutine = createRoutine("app/auth/VERIFY_OTP_HASH");
export const otpRequestRoutine = createRoutine("app/auth/OTP_REQUEST");
export const CLEAR_VALIDATION_ERROR =
  "app/auth/register/CLEAR_VALIDATION_ERROR";

export const clearValidationError = createAction(
  CLEAR_VALIDATION_ERROR,
  field => ({ field })
);

export const initialState = {
  loading: false,
  verifyLoading: false,
  otpRequestLoading: false,
  otpLastSentAt: null,
  error: null
};

function mapValidationErrors(validation) {
  const validationErrors = {};
  const items = Array.isArray(validation) ? validation : [];

  for (let field of items) {
    validationErrors[field.field] = field.value;
  }

  return validationErrors;
}

export default handleActions(
  {
    [registerRoutine.TRIGGER]: state => ({
      ...state,
      loading: true,
      error: null
    }),
    [registerRoutine.SUCCESS]: state => ({
      ...state,
      loading: false,
      otpLastSentAt: Date.now()
    }),
    [registerRoutine.FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: mapValidationErrors(action.payload)
    }),
    [verifyOtpRoutine.TRIGGER]: state => ({
      ...state,
      verifyLoading: true,
      error: null
    }),
    [verifyOtpRoutine.SUCCESS]: state => ({
      ...state,
      verifyLoading: false
    }),
    [verifyOtpRoutine.FAILURE]: (state, action) => ({
      ...state,
      verifyLoading: false,
      error: mapValidationErrors(action.payload)
    }),
    [verifyOtpHashRoutine.TRIGGER]: state => ({
      ...state,
      verifyLoading: true,
      error: null
    }),
    [verifyOtpHashRoutine.SUCCESS]: state => ({
      ...state,
      verifyLoading: false
    }),
    [verifyOtpHashRoutine.FAILURE]: (state, action) => ({
      ...state,
      verifyLoading: false,
      error: mapValidationErrors(action.payload)
    }),
    [otpRequestRoutine.TRIGGER]: state => ({
      ...state,
      otpRequestLoading: true,
      error: null
    }),
    [otpRequestRoutine.SUCCESS]: state => ({
      ...state,
      otpRequestLoading: false,
      otpLastSentAt: Date.now()
    }),
    [otpRequestRoutine.FAILURE]: (state, action) => ({
      ...state,
      otpRequestLoading: false,
      error: mapValidationErrors(action.payload)
    }),
    [clearValidationError]: (state, action) => {
      let validationErrors = { ...state.error };

      delete validationErrors[action.payload.field];

      return {
        ...state,
        error: validationErrors
      };
    }
  },
  initialState
);
